import type { CommunityDetail } from 'models';
import { Card } from 'ui';
import { UserList } from '../user-list';

type P = {
  community: CommunityDetail;
};

const Administrators = ({ community }: P) => (
  <Card title="Administrators">
    <UserList users={community.administrators} />
  </Card>
);

export default Administrators;
